import React from "react";

import {DateFormatter} from "../../../services/date";
import QuoteService from "../../../services/quotes";

import LabelIcon from '@mui/icons-material/Label';
import PeopleIcon from "@mui/icons-material/People";
import AlternateEmailIcon from '@mui/icons-material/AlternateEmail';
import AccessTimeIcon from '@mui/icons-material/AccessTime';
import NoteAddIcon from '@mui/icons-material/NoteAdd';
import FlagIcon from '@mui/icons-material/Flag';
import PetsIcon from '@mui/icons-material/Pets';
import List from "@mui/material/List";
import ListItem from "@mui/material/ListItem";
import ListItemIcon from "@mui/material/ListItemIcon";
import TaskIcon from '@mui/icons-material/Task';
import EventBusyIcon from '@mui/icons-material/EventBusy';
import ListItemText from "@mui/material/ListItemText";
import Divider from "@mui/material/Divider";
import Card from "@mui/material/Card";


const QuoteDetails = ({quote}) => {
    const attributes = [
        {
            value: `${quote.name} ${quote.surname}`,
            defaultValue: "",
            label: "Nome e Cognome",
            icon: <LabelIcon/>,
        },
        {
            value: quote.nationality.label,
            defaultValue: "",
            label: "Nazionalità",
            icon: <FlagIcon/>,
        },
        {
            value: `Adulti ${quote.adults}, Bambini ${quote.children}`,
            defaultValue: 0,
            label: "Adulti e Bambini",
            icon: <PeopleIcon/>,
        },
        {
            value: quote.petsNumber,
            defaultValue: 0,
            label: "Animali domestici",
            icon: <PetsIcon/>,
        },
        {
            value: quote.email,
            defaultValue: "",
            label: "Email",
            icon: <AlternateEmailIcon/>,
        },
        {
            value: DateFormatter.dateAndTime(quote.createdAt),
            defaultValue: "",
            label: "Data creazione",
            icon: <NoteAddIcon/>,
        },
        {
            value: QuoteService.utils.getConfirmationPolicyText(quote.bookingCondition.confirmationPolicy, quote.bookingCondition.depositPercentage),
            defaultValue: "",
            label: "Politica conferma",
            icon: <TaskIcon/>,
        },
        {
            value: QuoteService.utils.getCancellationPolicyText(quote.bookingCondition.cancellationPolicy, quote.bookingCondition.refundableUntil),
            defaultValue: "",
            label: "Politica cancellazione",
            icon: <EventBusyIcon/>,
        },
        {
            value: DateFormatter.shortString(quote.expiration),
            defaultValue: "",
            label: "Preventivo valido fino",
            icon: <AccessTimeIcon/>,
        },
        {
            value: QuoteService.utils.getTouristTaxPolicyText(quote.bookingCondition.touristTaxPolicy, quote.bookingCondition.touristTaxUnitPrice),
            defaultValue: "",
            label: "Politica tassa di soggiorno",
            icon: <AccessTimeIcon/>,
        }
    ]

    return <Card>
        <List disablePadding>
            {
                attributes.map(({value, defaultValue, label, icon}, i) => (
                    <React.Fragment key={label}>
                        <ListItem>
                            <ListItemIcon>
                                {icon}
                            </ListItemIcon>
                            <ListItemText primary={value || defaultValue}
                                          secondary={label}/>
                        </ListItem>
                        {i !== attributes.length - 1 && <Divider variant="inset"/>}
                    </React.Fragment>
                ))
            }

        </List>
    </Card>
}

export default QuoteDetails;